module.exports = __webpack_public_path__ + "static/business-interview-bc627982ff2a84db8da172508f6a93a8.svg";